<template>
  <main-page :user="user" color="blue">
    <template v-slot:title>TVR FEEDBACK</template>

    <div class="container">
      <div class="row content" v-if="!selectedAssignment">
        <div class="col-4 zone-padding pt-4 text-left">
          <h1 class="mt-4 mb-2 si-font si-text-yellow">Student</h1>
          <config-select
            v-if="user.role != 'STUDENT'"
            class="vs-big"
            :options="studentOptions"
            :clearable="false"
            :nullOption="true"
            nullText="All"
            sortBy="last"
            v-model="selectedStudent"
          />
          <div v-if="user.role == 'STUDENT'" class="text-lg">
            {{ fs.displayName(user.name) }}
          </div>
          <h1 class="mt-4 mb-2 si-font si-text-blue">Category</h1>
          <config-select
            class="vs-big"
            :options="categoryOptions"
            :clearable="false"
            :nullOption="true"
            nullText="All"
            sortBy="sequence"
            v-model="selectedCategory"
          />
          <h1 class="mt-4 mb-2 si-font si-text-green">TVR assignments</h1>
          <div v-for="assignment in tvrAssignments" :key="assignment.id">
            <div v-if="user.role == 'STUDENT'">
              <div
                v-if="getFeedbackCount(assignment.id, user.id) > 0"
                class="card mt-2 px-2 clickable-card clickable"
                @click="goToMyFeedback(assignment.id)"
              >
                <div class="flex text-left text-lg">
                  {{ assignment.name }}
                </div>
                <div class="text-muted text-md">
                  {{ getFeedbackCount(assignment.id, user.id) }} feedback
                </div>
              </div>
              <div
                v-if="getFeedbackCount(assignment.id, user.id) == 0"
                class="card mt-2 px-2"
              >
                <div class="flex text-left text-lg">
                  {{ assignment.name }}
                </div>
                <div class="text-muted text-md">No feedback</div>
              </div>
            </div>
            <div v-else>
              <div
                class="card mt-2 px-2 clickable-card clickable"
                @click="selectedAssignment = assignment"
              >
                <div class="flex text-left text-lg">
                  {{ assignment.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-8 zone-padding text-left d-flex flex-column justify-content-center h-100"
        >
          <apex-chart
            v-if="chartData.length <= 100"
            ref="chart"
            type="line"
            :options="chartOptions"
            :series="chartData"
            height="500px;"
            class="mt-4"
          ></apex-chart>
          <div v-if="chartData.length > 100" class="card p-5 mb-5">
            <div class="text-center text-very-muted text-lg _800">
              Too much data for line graph
            </div>
            <div class="text-center text-very-muted text-lg _800">
              Export to view data
            </div>
          </div>
          <div v-if="showStats" class="ml-5 px-4 py-2 text-md border">
            <div class="text-center">
              <h3
                class="my-0 si-font text-center"
                style="display: inline-block"
              >
                STATISTICS
              </h3>
              <span> {{ getTitle() }}</span>
            </div>
            <div>
              <strong>Range: </strong>
              <span v-if="rangeLow != rangeHigh"
                >{{ fs.round1d(rangeLow) }} to {{ fs.round1d(rangeHigh) }}</span
              >
              <span v-if="rangeLow == rangeHigh">{{
                fs.round1d(rangeLow)
              }}</span>
            </div>
            <div class="d-flex flex-row justify-content-between">
              <div class="d-flex flex-row align-items-center">
                <strong>Mean:</strong
                ><span class="ml-1">{{ fs.round1d(mean) }}</span>
              </div>
              <div class="d-flex flex-row align-items-center ml-3">
                <strong>Median:</strong
                ><span class="ml-1">{{ fs.round1d(median) }}</span>
              </div>
              <div class="d-flex flex-row align-items-center ml-3">
                <template v-if="selectedCategory">
                  <strong>Mode:</strong><span class="ml-1">{{ mode }}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row content" v-if="selectedAssignment">
        <template>
          <div v-for="team in teams" :key="team.id" class="col-12 col-md-4">
            <div class="mt-3 card">
              <div class="card-header text-md success _600">
                {{ team.name }}
              </div>
              <div class="card-body pb-2">
                <div v-for="member in team.members" :key="member.id">
                  <div
                    v-if="
                      getFeedbackCount(selectedAssignment.id, member.id) > 0
                    "
                    class="d-flex flex-row align-items-center border mb-2 clickable clickable-card py-2 px-3"
                    @click="goToFeedback(member.id)"
                  >
                    <div class="flex text-left">
                      {{ fs.displayName(member.user.name) }}
                    </div>
                    <div class="text-muted">
                      {{ getFeedbackCount(selectedAssignment.id, member.id) }}
                      feedback
                    </div>
                  </div>
                  <div
                    v-if="
                      getFeedbackCount(selectedAssignment.id, member.id) == 0
                    "
                    class="d-flex flex-row align-items-center border mb-2 py-2 px-3"
                  >
                    <div class="flex text-left">
                      {{ fs.displayName(member.user.name) }}
                    </div>
                    <div class="text-muted">No feedback</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <template v-slot:footer>
      <div class="col-6 row no-gutters text-right">
        <div class="dropdown dropdown-menu-right dropup" style="flex:1;">
          <button
            class="btn btn-si-secondary dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Export
          </button>
          <div
            class="dropdown-menu text-md"
            aria-labelledby="dropdownMenuButton"
          >
            <button class="dropdown-item" @click="exportFeedback">
              All Feedback
            </button>
          </div>
        </div>
        <button
          class="btn btn-si-secondary ml-3"
          v-if="selectedAssignment"
          @click="goBack"
        >
          Back
        </button>
        <a
          class="btn btn-si-secondary ml-3"
          v-if="!selectedAssignment"
          href="#/tvr"
          >Back</a
        >
      </div>
    </template>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import ConfigSelect from "@/components/ConfigSelect";
import ApexChart from "vue-apexcharts";

import SectionService from "@/services/SectionService";
import TVRService from "@/services/TVRService";
import ProgramService from "@/services/ProgramService";
import FileService from "@/services/FileService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import _ from "lodash";

var assignmentNames = {};

export default {
  name: "TVRFeedbacks",

  props: ["user"],

  components: { MainPage, ConfigSelect, ApexChart },

  data() {
    return {
      fs: fs,

      program: null,
      context: null,
      teams: null,
      students: null,
      feedbackCounts: null,
      tvrTeams: null,
      tvrAssignments: [],
      tvrs: null,
      selectedAssignment: null,

      categoryOptions: [],
      selectedCategory: null,
      studentOptions: [],
      selectedStudent: null,

      chartOptions: {
        chart: {
          id: "vuechart-example",
          zoom: {
            enabled: false,
          },
          toolbar: {
            tools: {
              download: false,
            },
          },
        },
        title: {
          text: "Team Collaboration Progress",
          align: "center",
          style: {
            fontSize: "20px",
          },
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            style: {
              fontSize: "20px",
            },
          },
          title: {
            text: "Assignment",
            style: {
              fontSize: "20px",
            },
          },
        },
        yaxis: [{
          min: 0,
          max: 100,
          tickAmount: 10,
          forceNiceScale: true,
          decimalsInFloat: 1,
          labels: {
            show: true,
            style: {
              fontSize: "20px",
            },
          },
          title: {
            text: "Rating",
            style: {
              fontSize: "20px",
            },
          },
        }],
        tooltip: {
          style: {
            fontSize: "20px",
          },
          x: {
            formatter: (value) => {
              let catName = assignmentNames[value];
              return catName || value;
            },
          },
        },
        legend: {
          fontSize: "20px",
        },
        colors: [
          "#2554C7",
          "#66DA26",
          "#E42217",
          "#FF9800",
          "#8D38C9",
          "#EA428B",
          "#3BB9FF",
          "#347235",
          "#848482",
          "#EAC117",
        ],
        stroke: {
          curve: "smooth",
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "14px",
            fontWeight: "bold",
          },
          formatter: function (val) {
            if (val == null) {
              return "N/A";
            }
            return val.toFixed(1);
          },
        },
        grid: {
          padding: {
            left: 30,
            right: 30,
          },
        },
      },
      chartData: [],

      showStats: false,
      mean: 0,
      median: 0,
      mode: "",
      rangeLow: 0,
      rangeHigh: 0,
    };
  },

  watch: {
    selectedAssignment() {
      console.log("TVR ASSIGNMENT CHANGED");
      this.constructTVROptions();
    },
    selectedCategory() {
      this.setChartData();
    },
    selectedStudent() {
      this.setChartData();
    },
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      BB.props({
        program: ProgramService.getContextProgram(),
        context: SectionService.getContextPrefilled(),
        counts: TVRService.getReceivedFeedbackCounts(),
        tvrs: TVRService.getContextFeedbacks(),
      })
        .then((r) => {
          this.loading = false;
          this.program = r.program.data;

          this.context = r.context.data;
          this.students = this.context.students || [];
          this.teams = this.context.teams;
          this.teams = _.sortBy(this.teams, "name");

          _.each(this.teams, (team) => {
            team.students = _.filter(team.students, (s) => {
              return this.context.student_ids.includes(s.id);
            });
          });

          if (this.user.role == "STUDENT") {
            this.tvrAssignments = _.filter(this.context.tvrs, {
              hide_feedback: false,
            });
          } else if (this.user.role == "PARTNER") {
            this.tvrAssignments = _.filter(this.context.tvrs, {
              show_feedback_partner: true,
            });
          } else {
            this.tvrAssignments = this.context.tvrs;
          }

          if (this.tvrAssignments.length < this.context.tvrs.length) {
            Notie.error("Some feedback has been hidden by teacher")
          }

          this.tvrs = r.tvrs.data;
          this.feedbackCounts = r.counts.data;
          console.log("COUNTS", this.feedbackCounts);
          this.categoryOptions = this.buildCategoryOptions();

          _.each(this.context.tvrs, (tvr, i) => {
            assignmentNames[i + 1] = tvr.name;
          });

          this.setChartData();

          if (this.user.role == "STUDENT") {
            this.selectedStudent = this.user;
          } else {
            this.studentOptions = this.buildStudentOptions();
          }
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          Notie.error("Failed to load Team Value Rubrics", e);
        });
    },

    getYMax(cat) {
      var max = 0;
      if (cat.id == "all") {
        for (var c of this.program.tvr_config.rubric.categories) {
          var c_max = this.getYMax(c);
          if (c_max > max) {
            max = c_max;
          }
        }
        return max;
      }

      for (var m of cat.marks) {
        if (m.tick > max) {
          max = m.tick;
        }
      }
      return max;
    },

    constructTVROptions() {
      if (!this.selectedAssignment) {
        console.log("NO ASSIGNMENT");
        return;
      }

      _.each(this.teams, (team) => {
        team.members = [];
        _.each(team.user_ids, (userID) => {
          let user = _.find(this.students, { id: userID });
          if (!user) {
            console.log(`User ${userID} in team ${team.name} not found`);
          } else {
            team.members.push({
              id: user.id,
              user: user,
            });
          }
        });
      });
    },

    goToMyFeedback(assignmentID) {
      this.$router.push(`/tvr_feedback/${assignmentID}/mine`);
    },

    goToFeedback(recipientID) {
      if (!(this.selectedAssignment && recipientID)) {
        Notie.error("An error occurred");
        console.error(
          "Cannot proceed to TVR feedback",
          this.selectedAssignment,
          recipientID
        );
        return;
      }

      this.$router.push(
        `/tvr_feedback/${this.selectedAssignment.id}/${recipientID}`
      );
    },

    getFeedbackCount(assignmentID, recipientID) {
      let count = _.find(this.feedbackCounts, {
        assignment_id: assignmentID,
        recipient_id: recipientID,
      });
      return count ? count.count : 0;
    },

    buildCategoryOptions() {
      console.log("BUILD");
      if (
        !this.program ||
        !this.program.tvr_config ||
        !this.program.tvr_config.rubric ||
        !this.program.tvr_config.rubric.categories
      ) {
        console.log("no");
        return [];
      }
      var options = [];
      var seq = 0;

      _.each(this.program.tvr_config.rubric.categories, (c) => {
        // let desc = this.getFocusDesc(this.program.profile_config.questions, strength.id);
        options.push({
          id: c.id,
          name: c.name,
          sequence: seq++,
          active: true,
        });
      });

      return options;
    },

    buildStudentOptions() {
      var options = [];
      var seq = 0;
      _.each(this.context.students, (s) => {
        options.push({
          id: s.id,
          name: fs.displayName(s.name),
          last: s.name.last,
          sequence: seq++,
          active: true,
        });
      });
      return options;
    },

    setChartData() {
      var cat = {id: "all"};
      if (this.selectedCategory != null) {
        cat = this.program.tvr_config.rubric.categories.filter(
          c => c.id == this.selectedCategory.id
        )[0];
      }
      console.log(this.getYMax(cat))
      this.chartOptions.yaxis[0].max = this.getYMax(cat)
      if (this.$refs.chart) {
        this.$refs.chart.updateOptions(this.chartOptions);
      }

      if (this.user.role == "STUDENT") {
        this.showStats = true;
        this.chartData = [
          { name: "Avg Score", data: this.studentChartData(this.user) },
        ];
      } else if (this.selectedStudent) {
        this.showStats = true;
        this.chartData = [
          {
            name: "Avg Score",
            data: this.studentChartData(this.selectedStudent),
          },
        ];
      } else {
        this.chartData = [];
        _.each(this.context.students, (s) => {
          var student_data = this.studentChartData(s);
          if (student_data.length > 0) {
            this.chartData.push({
              name: fs.displayName(s.name),
              data: this.studentChartData(s),
            });
          }
        });
      }

      this.chartOptions.legend.show = this.chartData.length <= 10;
      this.$refs.chart.updateOptions(this.chartOptions);
    },

    studentChartData(student) {
      var scores = [];
      var scoreSet = [];
      _.each(this.tvrAssignments, (a) => {
        var total_score = 0;
        var num_scores = 0;
        var tvrs = _.filter(this.tvrs, {
          assignment_id: a.id,
          recipient_id: student.id,
        });
        _.each(tvrs, (tvr) => {
          _.each(tvr.response.responses, (resp) => {
            if (
              !this.selectedCategory ||
              resp.category_id == this.selectedCategory.id
            ) {
              total_score += resp.score;
              num_scores += 1;
              scoreSet.push(resp.score);
            }
          });
        });
        if (num_scores > 0) {
            scores.push(total_score / num_scores);
        }
      });
      if (this.showStats) {
        [
          this.mean,
          this.median,
          this.mode,
          this.rangeLow,
          this.rangeHigh,
        ] = fs.statistics(scoreSet);
      }
      return scores;
    },

    getTitle() {
      if (this.selectedCategory) {
        return `, ${this.selectedCategory.name}`;
      }

      return "";
    },

    exportFeedback() {
      _.each(this.tvrs, (feedback) => {
        feedback.assignment = _.find(this.tvrAssignments, {
          id: feedback.assignment_id,
        });
      });
      FileService.exportTVRFeedback(
        this.tvrs.filter((tvr) => tvr.assignment),
        this.context,
        this.program.tvr_config.rubric.categories,
        this.user.role != "STUDENT" && this.user.role != "PARTNER"
      );
    },

    goBack() {
      this.selectedAssignment = null;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.button-container {
  display: flex;
  flex-direction: column;
  width: 170px;
}
.clickable-card {
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out;
  background-color: #f7f7f7;
}
.clickable-card:hover {
  transform: scale(1.05);
  background-color: #f0f0f0;
}
</style>
